export default __webpack_public_path__ + "static/assets/med_spheric_solid_03.cac415b5.png";